function openDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("CacheDB", 1);

    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains("cache")) {
        db.createObjectStore("cache");
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function clearCache(prefix = "fetch") {
  const db = await openDatabase();
  const transaction = db.transaction("cache", "readwrite");
  const store = transaction.objectStore("cache");

  await new Promise<void>((resolve, reject) => {
    const request = store.openCursor();
    request.onerror = () => reject(request.error);
    request.onsuccess = () => {
      const cursor = request.result;
      if (cursor) {
        if (typeof cursor.key === "string" && cursor.key.startsWith(prefix)) {
          cursor.delete();
        }
        cursor.continue();
      } else {
        resolve();
      }
    };
  });
}

export async function getCachedData<T>(
  key: string,
  fetcher: () => Promise<T>
): Promise<T> {
  const db = await openDatabase();

  const cachedData = await new Promise<T | undefined>((resolve, reject) => {
    const transaction = db.transaction("cache", "readonly");
    const store = transaction.objectStore("cache");
    const request = store.get(key);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

  if (cachedData) {
    return cachedData;
  }

  const data = await fetcher();

  await new Promise<void>((resolve, reject) => {
    const transaction = db.transaction("cache", "readwrite");
    const store = transaction.objectStore("cache");
    const request = store.put(data, key);
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });

  return data;
}
